module.exports = __webpack_public_path__ + "static/media/14plgprofesional.2f9f20f7.jpg";